<template>
  <span class="gs-transaction-status" :aria-hidden="badges.length ? null : 'true'">
    <span v-for="badge in badges" :key="badge.key" tabindex="0" role="img"
      class="gs-transaction-status__indicator" :aria-label="badge.label"
      v-tooltip="tooltip(badge.label)" @click.stop>
      <transaction-status-icon :icon="badge.icon" :tone="badge.tone" />
    </span>
  </span>
</template>
<script>
import { transactionBadges, needsRenewalCheck } from '@/helpers/transactionTableStatus';
import TransactionStatusIcon from './transactionStatusIcon.vue';
export default {
  components: { TransactionStatusIcon },
  props: { params: { type: Object, required: true } },
  data() { return { renewal: null, loading: false, disposed: false, requestVersion: 0 }; },
  computed: {
    badges() { return transactionBadges(this.params.data, this.renewal, this.loading); },
  },
  watch: { 'params.data': 'checkRenewal' },
  mounted() { this.checkRenewal(); },
  beforeDestroy() { this.disposed = true; this.requestVersion += 1; },
  methods: {
    async checkRenewal() {
      const version = ++this.requestVersion;
      this.renewal = null;
      this.loading = false;
      const row = this.params.data;
      if (!needsRenewalCheck(row)) return;
      this.loading = true;
      let state = null;
      try {
        const parent = this.params.context && this.params.context.componentParent;
        if (parent && parent.readTableRenewal) {
          state = await parent.readTableRenewal(row.id, () => !this.disposed && version === this.requestVersion);
        }
      } catch (_) { /* Keep the name visible when verification is unavailable. */ }
      if (!this.disposed && version === this.requestVersion) {
        this.renewal = state || { status: 'unavailable' };
        this.loading = false;
      }
    },
    tooltip(content) { return { content, classes: 'gs-transaction-tooltip', html: false, trigger: 'hover focus', delay: { show: 300, hide: 0 } }; },
  },
};
</script>
